import React, { useState, useEffect } from "react";
import { useTheme } from "../utils/ThemeContext";
import { Link } from "react-router-dom";

export default function Navbar(props) {
  const { theme, toggleTheme } = useTheme();

  const [mode, setMode] = useState(
    theme == "light" ? "fa fa-moon" : "fa fa-sun"
  );
  const [scroll, setScroll] = useState("");
  const changeMode = () => {
    if (mode === "fa fa-moon") {
      setMode("fa fa-sun");
    } else {
      setMode("fa fa-moon");
    }
    toggleTheme();
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScroll("nav-scrolled");
    } else {
      setScroll("");
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  // Responsive
  const [navToggle, setNavToggle] = useState("");
  const [itemToggle, setItemToggle] = useState("");
  const [toggleIcon, setToggleIcon] = useState("fa fa-bars");
  const [hide, setHide] = useState("hide");
  const handleToggle = () => {
    if (
      navToggle === "" &&
      itemToggle === "" &&
      toggleIcon === "fa fa-bars" &&
      hide === "hide"
    ) {
      setToggleIcon("fa fa-times");
      setNavToggle("nav-toggle");
      setItemToggle("item-toggle");
      setHide("");
    } else {
      setToggleIcon("fa fa-bars");
      setItemToggle("");
      setNavToggle("");
      setHide("hide");
    }
  };
  return (
    <header className={`${navToggle} ${scroll} h-[60px] sm:h-[65px]`}>
      <nav className="navbar">
        <div className="logo absolute left-0">
          <a href={"/#home"}>
            <h1 className="text-2xl">Rushi</h1>
          </a>
        </div>
        <div>
          <ul className="nav-items">
            <li>
              <a href="/#home" className="gap-1 nav-link group">
                <i class="fa fa-home" aria-hidden="true"></i>Home
              </a>
              <div class="hover-link"></div>
            </li>
            <li>
              <a href="/#about" className="gap-1 nav-link group">
                <i class="fa fa-user" aria-hidden="true"></i>About
              </a>
              <div class="hover-link"></div>
            </li>
            <li>
              <Link to="/projects" className="gap-1 nav-link group">
                <i class="fa-solid fa-diagram-project"></i>Projects
              </Link>
              <div class="hover-link"></div>
            </li>
            <li>
              <Link to="/experience" className="gap-1 nav-link group">
                <i class="fa fa-history" aria-hidden="true"></i>Experience
              </Link>
              <div class="hover-link"></div>
            </li>
            <li>
              <Link to="/gb" className="gap-1 nav-link group">
                <i class="fa fa-book" aria-hidden="true"></i>Guestbook
              </Link>
              <div class="hover-link"></div>
            </li>
          </ul>
        </div>
        <div className="absolute right-0">
          <ul className="flex items-center gap-4">
            <li>
              <a href="/#resume" className="resume-btn">
                Resume
              </a>
            </li>
            <i
              className={mode}
              onClick={changeMode}
              id="mode-switch"
              aria-hidden="true"
            ></i>
          </ul>
        </div>
      </nav>
      {/* Mobile Nav  */}
      <nav className="navbar-mobile">
        <div className="nav-head">
          <div className="logo">
            <h1 className="text-2xl font-semibold">Rushi</h1>
          </div>
          <div className="nav-options">
            <i
              className={mode}
              onClick={changeMode}
              id="mode-switch"
              aria-hidden="true"
            ></i>
            <i
              className={`${toggleIcon} nav-open text-3xl rounded-md shadow-md shadow-gray-400 px-2 py-0.5`}
              onClick={handleToggle}
              aria-hidden="true"
            ></i>
          </div>
        </div>
      </nav>
      <div className={hide}>
        <ul className={`nav-items-mobile ${itemToggle}`} onClick={handleToggle}>
          <li>
            <a href="/#home" className="nav-link">
              <i class="fa fa-home" aria-hidden="true"></i>Home
            </a>
          </li>
          <li>
            <a href="/#about" className="nav-link">
              <i class="fa fa-user" aria-hidden="true"></i>About
            </a>
          </li>
          <li>
            <Link to="/projects" className="nav-link">
              <i class="fa-solid fa-diagram-project"></i>Projects
            </Link>
          </li>
          <li>
            <Link to="/experience" className="nav-link">
              <i class="fa fa-history" aria-hidden="true"></i>Experience
            </Link>
          </li>
          <li>
            <Link to="/gb" className="nav-link">
              <i class="fa fa-book" aria-hidden="true"></i>Guestbook
            </Link>
          </li>
        </ul>
        <center>
          <a href="#resume" className="resume-btn" onClick={handleToggle}>
            Resume
          </a>
        </center>
      </div>
    </header>
  );
}
